import type { CheckboxProps } from "antd";
import { Checkbox as AntdCheckbox } from "antd";
import { CheckSquare, Square, SquareDot } from "lucide-react";
import styles from "./styles.module.scss";

export type { CheckboxProps };

export interface CustomIconCheckboxProps extends CheckboxProps {
  iconSize?: number;
}

export function Checkbox({
  iconSize = 18,
  className,
  children,
  disabled,
  ...props
}: CustomIconCheckboxProps) {
  const isChecked = props.checked || false;
  const isIndeterminate = props.indeterminate || false;
  const isDisabled = disabled || false;

  return (
    <label
      className={`${styles.checkboxWrapper} ${isDisabled ? styles.disabled : ""} ${className || ""}`}
    >
      <div className={styles.iconContainer}>
        <AntdCheckbox
          {...props}
          disabled={isDisabled}
          className={styles.customCheckbox}
        />
        {isIndeterminate ? (
          <SquareDot
            size={iconSize}
            className={`${styles.checkboxIconIndeterminate} ${isDisabled ? styles.checkboxIconDisabled : ""}`}
          />
        ) : isChecked ? (
          <CheckSquare
            size={iconSize}
            className={`${styles.checkboxIconSelected} ${isDisabled ? styles.checkboxIconDisabled : ""}`}
          />
        ) : (
          <Square
            size={iconSize}
            className={`${styles.checkboxIcon} ${isDisabled ? styles.checkboxIconDisabled : ""}`}
          />
        )}
      </div>
      {children && <span>{children}</span>}
    </label>
  );
}

Checkbox.Group = AntdCheckbox.Group;
